export default __webpack_public_path__ + "static/2-24919ace6dfe5a068de35b3038a4de85.jpg";